import {
  categoriesPrettifier,
} from '@analytic/utils'

export default function analyticCartAdd(
  name, id, price, quantity, brand = '', categories = ''
) {
  if (!window.is_analytic_enabled) return
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: window.currency_code,
      items: [{
        item_name: name,
        item_id: id,
        price,
        item_brand: brand,
        ...categoriesPrettifier(categories),
        quantity,
      }],
    },
  })
}
